{
  "activity_start_time": "Heure de début de l'activité",
  "type": {
    "type_of_start_time": "Type d'heure de début",
    "relative": "Relatif à la session/à l'élément programmé",
    "relative_description": "Exemple : 2 minutes après le début de la session ou 5 minutes après le dernier élément programmé",
    "fixed": "Fixé",
    "fixed_description": "Exemple : 09:00",
    "relative_time": "Temps relatif",
    "fixed_time": "Heure fixe"
  },
  "start_activity": "Commencer l'activité",
  "preposition": {
    "before": "avant",
    "after": "après"
  },
  "preposition_lables": {
    "before": "avant le démarrage de {{ type }}",
    "after": "après le démarrage de {{ type }}"
  },
  "relative_to": {
    "start_time": "heure de début de",
    "end_time": "heure de fin de",
    "zero_time": "heure zéro de"
  },
  "relationship": {
    "every": "chaque",
    "specific": "spécifique",
    "first": "premier",
    "last": "dernier"
  },
  "related_type": {
    "Session": "session",
    "Scheduled item": "élément programmé"
  },
  "repeat_activity": {
    "repeat_activity": "Répéter l'activité",
    "repeat_on_all": "Répéter tous les jours (tous)",
    "none_selected": "Aucun sélectionné",
    "all_days": "Tous les jours"
  },
  "info": {
    "can_not_delete": "Impossible de supprimer cet élément du calendrier car il est utilisé par un autre élément du calendrier"
  }
}